export const DROPDOWN_WIDTH = 228;

export const SAVED_SEARCH_SUBMIT_DD_ANCHOR = "saved-search-submit-dd-anchor";
